import c from '../common';

export default {


  //Column
  "status": c.status.en,
  "available": "Available",
  "AccUnopened": "Registration In Progress",
  "disabled": "Disabled",

  "type": "Type",
  "general_assistant": c.general_assistant.en.uppercase,
  "takeaway_assistant": c.takeaway_assistant.en.uppercase,

  "phone": c.phone.en,
  "name": c.name.en.uppercase,
  "email": c.email.en,
  "description": c.description.en,

  //New Staff Pop-up
  "enterPhone": "Enter Staff Information",
  "cancel": c.cancel.en,
  "add": c.add.en,


  ///phone number
  "error1": "The phone number have been used. Please enter new number",
  "error2": "The email have been used. Please contact your Staff to open account with Mobile App.",
  "error3": "The email have been used. Please enter new E-mail.",
  "StaffPhoneNumber": "Phone (optional)",
  "rule1": "Please enter 8 digit phone number.",
  "rule2": "Phone number can only be Arabic numerals.",
  "rule3": "Phone number cannot contain space.",

  ///name
  "StaffName": "Staff Name",
  "enterName": "Please enter Staff Name",

  ///email
  "StaffEmail": "Staff Email",
  "enterEmail": "Please enter correct email",

  ///belongingshop
  "belongingVendor": "Belonging Company",



  //Title of the page
  "StaffMgtTitle": "Staff management",

  //Button to add new staff
  "addNewStaff": "Add New Staff",


  "description_1": "Invalid mobile number",
  "description_2": "Please contact Staff and open Mobile App to register with {{email}}",
  "description_3": "Registered, can use mobile app to login",
  "description_4": "Registered, can use this webiste to login",
  "description_5": "Regular Staff",
  "description_6": "Can sale, redeem all e-Vouchers, coupons",
  "description_7": "Takeaway Order Watcher",
  "description_8": "Can only view the takeaway order information",
  "description_9": "next",
};

